







import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import { StringFilter, StringFilterParameter } from "../../../../base/components/system/filters";
import { EditableFormatSummaryFilterParameter } from ".";

@Component({
  components: {
    StringFilter,
  },
})
export default class EditableFormatSummaryTagFilter extends Mixins(ModelEditableMixin) {
  readPropertyOrDefault: <T>(reader: (source: EditableFormatSummaryFilterParameter) => T, defaultValue: T) => T;
  writeProperty: (writer: (source: EditableFormatSummaryFilterParameter) => void) => void;

  get tag(): StringFilterParameter {
    return this.readPropertyOrDefault(s => s.tag, null);
  }

  set tag(source: StringFilterParameter) {
    this.writeProperty(s => s.tag = source);
  }
}
